'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _window = require('global/window');

var _window2 = _interopRequireDefault(_window);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStore() {
  var _props = this.props,
      store = _props.store,
      preloadedState = _props.preloadedState;

  if (!store) {
    var reducers = this.getReducers(this.props);
    var enhancers = this.getEnhancers(this.props);
    store = (0, _redux.createStore)(reducers, preloadedState, enhancers);
  }
  return store;
}
/**
 * redux 基础 provider
 * @prop { object } history browser、hash、memory，跟react-router挂钩，必填
 * @prop { object } store redux store
 *                  非必要的，如果有store，reducers、middlewares和enhancers,preloadedState就不生效，传进来也没有意义
 * @prop { array } middlewares redux middlewares
 * @prop { array } enhancers redux enhancers
 * @prop { object } reducers redux reducers (传进来后会被combineReducers)
 * @prop { any } preloadedState redux preloadedState
 * @prop { boolean } production 是否是生产环境
 */
var Provider = (_temp2 = _class = function (_React$Component) {
  _inherits(Provider, _React$Component);

  function Provider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Provider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Provider.__proto__ || Object.getPrototypeOf(Provider)).call.apply(_ref, [this].concat(args))), _this), _this.displayName = 'Provider', _this.state = {}, _this.store = getStore.bind(_this)(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Provider, [{
    key: 'getReducers',
    value: function getReducers(props) {
      var reducers = props.reducers;

      return (0, _redux.combineReducers)(_extends({}, reducers, {
        router: _reactRouterRedux.routerReducer
      }));
    }
  }, {
    key: 'getEnhancers',
    value: function getEnhancers(props) {
      var _props$enhancers = props.enhancers,
          enhancers = _props$enhancers === undefined ? [] : _props$enhancers,
          _props$middlewares = props.middlewares,
          middlewares = _props$middlewares === undefined ? [] : _props$middlewares,
          history = props.history,
          _props$production = props.production,
          production = _props$production === undefined ? true : _props$production;

      var devtools = function devtools() {
        return function (noop) {
          return noop;
        };
      };
      //如果localStorage.reduxTools=true，reduxTools强制打开。
      //给生产环境调试使用。
      if ((!production || JSON.parse(localStorage.getItem('reduxDevTools'))) && _window2.default.__REDUX_DEVTOOLS_EXTENSION__) {
        devtools = _window2.default.__REDUX_DEVTOOLS_EXTENSION__;
      } else {
        console.log('You have not install the redux-devtools-extension.');
        console.log('See https://github.com/zalmoxisus/redux-devtools-extension.');
      }
      var _middlewares = [].concat(_toConsumableArray(middlewares), [(0, _reactRouterRedux.routerMiddleware)(history)]);
      var _enhancers = [_redux.applyMiddleware.apply(undefined, _toConsumableArray(_middlewares)), devtools()].concat(_toConsumableArray(enhancers));
      return _redux.compose.apply(undefined, _toConsumableArray(_enhancers));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var store = nextProps.store,
          hot = nextProps.hot;
      //热替换处理，根据props.hot来处理

      if (!store && hot) {
        var reducers = this.getReducers(nextProps);
        this.store.replaceReducer(reducers);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          history = _props2.history,
          children = _props2.children;

      return _react2.default.createElement(
        _reactRedux.Provider,
        { store: this.store },
        _react2.default.createElement(
          _reactRouterRedux.ConnectedRouter,
          { history: history },
          _react2.default.createElement(
            'span',
            null,
            children
          )
        )
      );
    }
  }]);

  return Provider;
}(_react2.default.Component), _class.propTypes = {
  history: _propTypes2.default.object.isRequired,
  //非必要的，如果有store，reducers、middlewares和enhancers就不生效，传进来也没有意义
  store: _propTypes2.default.object,
  middlewares: _propTypes2.default.array,
  enhancers: _propTypes2.default.array,
  preloadedState: _propTypes2.default.any,
  reducers: _propTypes2.default.object,
  production: _propTypes2.default.bool
}, _temp2);
exports.default = Provider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-redux-provider/libs/provider.js
// module id = 90
// module chunks = 0